export class CandidatureRequest {
  constructor(
    public submissionDate: Date,
    public terms_condition: string,
    public firstName: string,
    public lastName: string,
    public dateBirth: Date,
    public age: number,
    public gender: string,
    public phoneNumber: string,
    public whatsappDispo: string,
    public whatsappNumber: string,
    public waveNumber: string = '',
    public email: string,
    public nationality: string,
    public right_nationality: string,
    public status: string,
    public level: string,
    public right_status: string,
    public high_diploma: string,
    public bac: string,
    public dut_bts_choice: string,
    public licence_master_choice: string,
    public doctorat_choice: string,
    public region: string,
    public right_region: string,
    public residence: string,
    public handicap: string,
    public right_handicap: string,
    public handicap_moteur: string,
    public handicap_visuel: string,
    public handicap_auditif: string,
    public handicap_autre: string,
    public situation: string,
    public family: string,
    public family_num: number,
    public lexp_Numerique: string,
    public forcen_know: string,
    public forcen_certif: string,
    public mark: number,
    public category: string,
    // Not Present Column
    public adresse_ip: string,
    public disponibilite: string,
    public projet_a_lissu: string,
    //public string ID_Unique,
    public cohorte: string,
    public confirmation: Boolean,
    public mailSent: Boolean,
    //public Long application,

    public prerequisiteResponseList: PrerequisiteDTO[],
    public  question1:string,
    public  question2:string,
    public  question3:string,
    public  question4:string,
    public  question5:string,
    public  question6:string,
    public  question7:string,
    public  question8:string,
    public  question9:string,
    public  question10:string,
    public  question11:string,
    public  question12:string,
    public  question13:string,
    public  question14:string
  ) {}
}

export class PrerequisiteDTO {
  constructor(
    public id: number,
    public name: string,
    public markPrereq: number
  ) {}
}
